import React, { FC, Fragment, useEffect } from 'react';
import { useCarrierImages } from '../../hooks/images/useCarrierImages';
import { CarrierId } from '../../types/api/primaryKeys/PrimaryKey';
import { Nullable } from '../../types/custom/Nullable';

interface Props {
    carrierId: CarrierId;
    carrierLogoFileName: Nullable<string>;
    altText: string;
}

export const CarrierImage: FC<Props> = ({ carrierId, carrierLogoFileName, altText }) => {
    const { updateCarrierImages, getCarrierImageUrl } = useCarrierImages();

    useEffect(() => {
        async function checkForNewImages(fileName: string) {
            await updateCarrierImages([{
                carrierId,
                carrierLogoFileName: fileName
            }]);
        }

        // Allow for a null file name, as in most cases
        // we're iterating a list of optionals. Just don't bother checking if the file name is truly
        // null.
        if (carrierLogoFileName) {
            checkForNewImages(carrierLogoFileName);
        }
    }, [carrierId, carrierLogoFileName]);

    const carrierImageUrl = getCarrierImageUrl(carrierId);

    if (!carrierImageUrl) {
        return <Fragment>{altText}</Fragment>;
    }

    return <img src={carrierImageUrl} alt={altText} className="enrollmentCarrierLogo" />;
};